module.exports = __webpack_public_path__ + "static/media/r13.67b2a99a.jpg";